
document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const prev = carousel.querySelector('[data-hero-prev]');
    const next = carousel.querySelector('[data-hero-next]');
    if (!slides.length) return;
    let index = 0;
    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const auto = () => window.setInterval(() => show(index + 1), 5000);
    let timer = auto();
    const reset = () => { window.clearInterval(timer); timer = auto(); };
    prev && prev.addEventListener('click', () => { show(index - 1); reset(); });
    next && next.addEventListener('click', () => { show(index + 1); reset(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); reset(); }));
    show(0);
  });


  document.querySelectorAll('[data-filter-root]').forEach((filterRoot) => {
    const chips = Array.from(filterRoot.querySelectorAll('.collection-filter-chip'));
    const cards = Array.from(filterRoot.querySelectorAll('[data-product-card]'));
    const clearButton = filterRoot.querySelector('[data-filter-clear]');
    const count = filterRoot.querySelector('[data-filter-count]');
    const emptyState = filterRoot.querySelector('[data-filter-empty]');
    if (!chips.length || !cards.length) return;

    const state = { size: new Set(), color: new Set() };

    const applyFilters = () => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const sizes = (card.dataset.sizes || '').split('|').map((value) => value.trim()).filter(Boolean);
        const colors = (card.dataset.colors || '').split('|').map((value) => value.trim()).filter(Boolean);

        const sizeMatch = !state.size.size || sizes.some((value) => state.size.has(value));
        const colorMatch = !state.color.size || colors.some((value) => state.color.has(value));
        const show = sizeMatch && colorMatch;

        card.hidden = !show;
        if (show) visibleCount += 1;
      });

      if (count) count.textContent = visibleCount;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (clearButton) clearButton.classList.toggle('is-active', state.size.size > 0 || state.color.size > 0);
    };

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const type = chip.dataset.filterType;
        const value = (chip.dataset.filterValue || '').trim().toLowerCase();
        if (!type || !value || !state[type]) return;

        if (state[type].has(value)) {
          state[type].delete(value);
          chip.classList.remove('is-active');
          chip.setAttribute('aria-pressed', 'false');
        } else {
          state[type].add(value);
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
        }

        applyFilters();
      });
    });

    clearButton && clearButton.addEventListener('click', () => {
      state.size.clear();
      state.color.clear();
      chips.forEach((chip) => {
        chip.classList.remove('is-active');
        chip.setAttribute('aria-pressed', 'false');
      });
      applyFilters();
    });

    applyFilters();
  });
});

// BFP safe motion reveal and light tilt effects
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var revealItems = document.querySelectorAll('[data-motion-reveal]');
    if ('IntersectionObserver' in window && revealItems.length) {
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function(item){ observer.observe(item); });
    } else {
      revealItems.forEach(function(item){ item.classList.add('is-visible'); });
    }

    document.querySelectorAll('[data-tilt-card]').forEach(function(card){
      card.addEventListener('mousemove', function(event){
        if (window.matchMedia('(max-width: 860px)').matches) return;
        var rect = card.getBoundingClientRect();
        var x = event.clientX - rect.left;
        var y = event.clientY - rect.top;
        var rotateX = ((y / rect.height) - 0.5) * -4;
        var rotateY = ((x / rect.width) - 0.5) * 4;
        card.style.transform = 'perspective(900px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function(){
        card.style.transform = '';
      });
    });
  });
})();

// BFP NAVE safe global interaction polish
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var progress = document.querySelector('[data-site-progress]');
    var updateProgress = function(){
      if (!progress) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var scrollHeight = (document.documentElement.scrollHeight - document.documentElement.clientHeight) || 1;
      var percent = Math.max(0, Math.min(100, (scrollTop / scrollHeight) * 100));
      progress.style.width = percent + '%';
    };
    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);

    var revealTargets = document.querySelectorAll('.hero, .quick-shop, .collection-grid, .featured-products, .brand-highlight, .newsletter-signup, .contact-landing, .policy-grid, .policy-nav, .main-collection, .main-product, .main-cart, .main-search, .footer-grid > *, .product-card, .collection-card, .brand-copy, .brand-stats, .quick-link, .card, .field, .filter-pill');
    revealTargets.forEach(function(el){
      if (!el.hasAttribute('data-motion-reveal')) el.setAttribute('data-motion-reveal', '');
    });

    var revealItems = document.querySelectorAll('[data-motion-reveal]');
    if ('IntersectionObserver' in window && revealItems.length) {
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach(function(item){
        if (!item.classList.contains('is-visible')) observer.observe(item);
      });
    } else {
      revealItems.forEach(function(item){ item.classList.add('is-visible'); });
    }

    document.querySelectorAll('.btn, .header-chip, .quick-link, .site-nav a').forEach(function(node){
      node.addEventListener('mouseenter', function(){ node.classList.add('is-hovering'); });
      node.addEventListener('mouseleave', function(){ node.classList.remove('is-hovering'); });
    });
  });
})();


// BFP AJAX add-to-cart + collection quick add variant selectors
(function(){
  function moneyFromCents(cents){
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '$' + amount;
  }

  function cartAddUrl(){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return root + 'cart/add.js';
  }

  function cartUrl(){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function updateCartLinks(count){
    document.querySelectorAll('.header-chip--cart, .mobile-cart-top').forEach(function(link){
      link.textContent = count > 0 ? 'View Cart (' + count + ')' : 'View Cart';
    });
  }

  function ensureToast(){
    var toast = document.querySelector('[data-bfp-cart-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'bfp-cart-toast';
    toast.setAttribute('data-bfp-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<strong>Added to cart</strong><span>Your item was added. Check out or keep shopping.</span><div><a href="/cart">View Cart</a><button type="button" data-bfp-toast-close>Keep Shopping</button></div>';
    document.body.appendChild(toast);

    toast.querySelector('[data-bfp-toast-close]').addEventListener('click', function(){
      toast.classList.remove('is-visible');
    });

    return toast;
  }

  function showToast(message){
    var toast = ensureToast();
    var strong = toast.querySelector('strong');
    if (strong && message) strong.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._timer);
    toast._timer = window.setTimeout(function(){
      toast.classList.remove('is-visible');
    }, 3800);
  }

  function initVariantPickers(){
    document.querySelectorAll('[data-bfp-option-root]').forEach(function(root){
      if (root.dataset.bfpReady === 'true') return;
      root.dataset.bfpReady = 'true';

      var form = root.closest('form');
      if (!form) return;

      var script = root.querySelector('[data-bfp-variants-json]');
      var idInput = form.querySelector('[data-bfp-variant-id]');
      var button = form.querySelector('button[type="submit"]');
      var selects = Array.prototype.slice.call(root.querySelectorAll('[data-bfp-option-position]'));
      var priceTarget = form.closest('.product-card') ? form.closest('.product-card').querySelector('[data-bfp-card-price]') : null;
      var variants = [];

      try {
        variants = JSON.parse(script ? script.textContent : '[]');
      } catch(error) {
        variants = [];
      }

      function selectedOptions(){
        return selects
          .sort(function(a,b){ return Number(a.dataset.bfpOptionPosition) - Number(b.dataset.bfpOptionPosition); })
          .map(function(select){ return select.value; });
      }

      function findVariant(){
        var selected = selectedOptions();
        return variants.find(function(variant){
          return selected.every(function(value, index){
            return variant.options && variant.options[index] === value;
          });
        });
      }

      function update(){
        var variant = findVariant();

        if (!variant) {
          if (button) {
            button.disabled = true;
            button.textContent = 'Unavailable';
          }
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceTarget && typeof variant.price !== 'undefined') {
          priceTarget.textContent = moneyFromCents(variant.price);
        }

        if (button) {
          if (variant.available) {
            button.disabled = false;
            button.textContent = 'Add to cart';
          } else {
            button.disabled = true;
            button.textContent = 'Sold out';
          }
        }
      }

      selects.forEach(function(select){
        select.addEventListener('change', update);
      });

      update();
    });
  }

  function initAjaxCartForms(){
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
      if (form.dataset.bfpAjaxReady === 'true') return;
      form.dataset.bfpAjaxReady = 'true';

      form.addEventListener('submit', function(event){
        var submitter = event.submitter || document.activeElement;

        if (submitter && submitter.closest && submitter.closest('.shopify-payment-button')) {
          return;
        }

        event.preventDefault();

        var button = submitter && submitter.matches && submitter.matches('button[type="submit"]') ? submitter : form.querySelector('button[type="submit"]');
        var status = form.querySelector('[data-bfp-form-status]');
        var originalText = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }
        if (status) status.textContent = '';

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
        .then(function(response){
          if (!response.ok) {
            return response.json().then(function(data){
              throw new Error(data.description || data.message || 'Unable to add item.');
            });
          }
          return response.json();
        })
        .then(function(){
          return fetch(cartUrl(), { headers: { 'Accept': 'application/json' } });
        })
        .then(function(response){ return response.json(); })
        .then(function(cart){
          updateCartLinks(cart.item_count || 0);
          if (status) status.textContent = 'Added. Cart updated.';
          showToast('Added to cart');
        })
        .catch(function(error){
          if (status) status.textContent = error.message || 'Could not add item.';
          showToast(error.message || 'Could not add item');
        })
        .finally(function(){
          if (button) {
            button.disabled = false;
            button.textContent = originalText || 'Add to cart';
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initVariantPickers();
    initAjaxCartForms();
  });

  document.addEventListener('shopify:section:load', function(){
    initVariantPickers();
    initAjaxCartForms();
  });
})();


// BFP cart remove buttons
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-remove-cart-item]').forEach(function(button){
      button.addEventListener('click', function(){
        var key = button.getAttribute('data-cart-item-key');
        if (!key) return;

        var quantityInput = document.getElementById('updates_' + key);
        if (quantityInput) {
          quantityInput.value = 0;
        }

        var form = button.closest('form');
        if (!form) return;

        var updateButton = form.querySelector('button[name="update"]');
        if (updateButton) {
          updateButton.click();
        } else {
          form.submit();
        }
      });
    });
  });
})();

// BFP rebuild: safe card carousel + recently viewed rail
(function(){
  function setupCarousels(){
    document.querySelectorAll('[data-card-carousel]').forEach(function(carousel){
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';
      var track = carousel.querySelector('[data-carousel-track]');
      if (!track) return;
      var total = track.children.length;
      var index = 0;
      function show(nextIndex){
        if (!total) return;
        index = (nextIndex + total) % total;
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
      }
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(index - 1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(index + 1); });
      var startX = 0;
      carousel.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; }, {passive:true});
      carousel.addEventListener('touchend', function(e){
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) show(index + (diff > 0 ? 1 : -1));
      }, {passive:true});
    });
  }
  function readRecent(){
    try { return JSON.parse(localStorage.getItem('bfpRecentlyViewed') || '[]'); } catch(e){ return []; }
  }
  function writeRecent(items){
    try { localStorage.setItem('bfpRecentlyViewed', JSON.stringify(items.slice(0, 8))); } catch(e){}
  }
  function captureCurrentProduct(){
    var el = document.querySelector('[data-current-product]');
    if (!el) return;
    var item = {
      handle: el.dataset.productHandle,
      title: el.dataset.productTitle,
      url: el.dataset.productUrl,
      image: el.dataset.productImage,
      price: el.dataset.productPrice
    };
    if (!item.handle || !item.url) return;
    var items = readRecent().filter(function(existing){ return existing.handle !== item.handle; });
    items.unshift(item);
    writeRecent(items);
  }
  function renderRecent(){
    document.querySelectorAll('[data-recently-viewed-section]').forEach(function(section){
      var grid = section.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      var current = document.querySelector('[data-current-product]');
      var currentHandle = current ? current.dataset.productHandle : '';
      var items = readRecent().filter(function(item){ return item.handle && item.handle !== currentHandle; }).slice(0, 4);
      if (!items.length) return;
      grid.innerHTML = items.map(function(item){
        var image = item.image ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g,'&quot;') + '">' : '';
        return '<a class="bfp-recent-card" href="' + item.url + '"><div class="bfp-recent-card__image">' + image + '</div><strong>' + item.title + '</strong><span>' + item.price + '</span></a>';
      }).join('');
      section.hidden = false;
    });
  }
  document.addEventListener('DOMContentLoaded', function(){
    setupCarousels();
    renderRecent();
    captureCurrentProduct();
  });
})();
